<div class="patient-consent-page">
  <div class="consent-box">
    <div class="consent-top">
      <h2>Patient Admission Consent</h2>
      <p>Hospital Admission, Billing, Data Sharing and Finance Consent</p>
    </div>

    <div class="consent-body" *ngIf="!isLoading">
      <div class="alert alert-success" *ngIf="isSubmitted">
        Consent submitted successfully. You may close this page.
      </div>

      <h5>Consent Summary</h5>

      <p>
        By signing this consent, you confirm that you understand and agree to the
        hospital admission process, treatment support, billing responsibility,
        deposit requirements, discharge clearance process, Nishwik data sharing
        and, if selected, loan/EMI processing terms.
      </p>

      <button
        type="button"
        class="btn btn-link p-0"
        (click)="showFullConsent = !showFullConsent"
      >
        {{ showFullConsent ? "Hide Full Consent" : "Read Full Consent" }}
      </button>

      <div class="full-consent-box mt-3" *ngIf="showFullConsent">
        <pre>{{ consentText }}</pre>
      </div>

      <div class="form-check mt-4">
        <input
          class="form-check-input"
          type="checkbox"
          id="agreeCheck"
          [(ngModel)]="isAgreed"
          [disabled]="isSubmitted"
        />

        <label class="form-check-label" for="agreeCheck">
          I have read and understood the consent. I voluntarily agree.
        </label>
      </div>

      <button
        type="button"
        class="btn submit-consent-btn mt-4"
        [disabled]="!isAgreed || isSubmitting || isSubmitted"
        (click)="submitConsent()"
      >
        <span
          class="spinner-border spinner-border-sm me-2"
          *ngIf="isSubmitting"
        ></span>
        I Agree & Submit Consent
      </button>
    </div>
  </div>
</div>